import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import RichTextEditor from '../RichTextEditor';

interface ExplanationEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const ExplanationEditor: React.FC<ExplanationEditorProps> = ({ value, onChange }) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
        💡 Explanation
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Provide a detailed explanation for the correct answer. This helps students understand the concept and learn from their mistakes.
      </Typography>
      
      <Box sx={{ minHeight: 150 }}>
        <RichTextEditor
          value={value}
          onChange={onChange}
          placeholder="Explain why the correct answer is right and why other options are wrong..."
          height={150}
        />
      </Box>
      
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        💡 Tip: Include step-by-step reasoning, relevant formulas, or concepts that students should understand.
      </Typography>
    </Paper>
  );
};

export default ExplanationEditor;
